import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type PartnerSharesTableHeaderProps = {
  isAdmin: boolean;
  hasSharesTitlesEnabled: boolean;
  isCoOwner?: boolean;
};

const PartnerSharesTableHeader: FC<PartnerSharesTableHeaderProps> = ({
  isAdmin,
  hasSharesTitlesEnabled,
  isCoOwner,
}: PartnerSharesTableHeaderProps) => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr>
        <th scope="col" className="d-none d-md-table-cell w-20px">
          {t('Nr')}
        </th>

        <th scope="col" className="text-right">
          {t('NrPart.')}
        </th>

        {!isCoOwner && (
          <th scope="col" className="text-right d-none d-md-table-cell">
            {t('Nominal')}
          </th>
        )}

        {isCoOwner && (
          <th scope="col" className="text-center d-none d-md-table-cell">
            {t('EncumbranceType')}
          </th>
        )}

        <th scope="col" className="text-center">
          {t('Class')}
        </th>

        <th scope="col" className="text-right d-table-cell d-md-none">
          {t('From/to')}
        </th>

        <th scope="col" className="text-right d-none d-md-table-cell">
          {t('From')}
        </th>

        <th scope="col" className="text-right d-none d-md-table-cell">
          {t('To')}
        </th>

        {isAdmin && !isCoOwner && (
          <th scope="col" className="text-right d-none d-md-table-cell">
            {t('Encumbrance')}
          </th>
        )}

        {hasSharesTitlesEnabled && isAdmin && !isCoOwner && (
          <th scope="col" className="text-center d-none d-md-table-cell">
            {t('Title')}
          </th>
        )}
      </tr>
    </thead>
  );
};

export default PartnerSharesTableHeader;
